import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import PropertyRadio from './components/PropertyRadio';
import PropertyDropdown from './components/PropertyDropdown';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { THERMAL_PROTECTION } from '../../../../../../utils/constantFeatures';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { getErrorIssues } from '../../../../../../utils/validationSummary';
import { Trans } from 'react-i18next';
class ThermalProtection extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[THERMAL_PROTECTION.enable].value === "1" ? true : false,
            isEnabledShutOffResistor: this.props.properties[THERMAL_PROTECTION.shutOffResistorBased].value ? true : false,
            isEnabledShutOffTemperature: this.props.properties[THERMAL_PROTECTION.shutOffTemperatureBased] && this.props.properties[THERMAL_PROTECTION.shutOffTemperatureBased].value ? true : false
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;

        if (this.getCorrectPropertyName(propertyName) === THERMAL_PROTECTION.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }

        this.props.handleChange(propertyName, v);
    }

    render() {
        const enable = this.props.properties[THERMAL_PROTECTION.enable];
        const mode = this.props.properties[THERMAL_PROTECTION.mode];
        const deratingLevel = this.props.properties[THERMAL_PROTECTION.deratingLevel];
        const sensorType = this.props.properties[THERMAL_PROTECTION.sensorType];

        const startDerating = mode.value === '0'
            ? this.props.properties[THERMAL_PROTECTION.startDeratingResistorBased]
            : this.props.properties[THERMAL_PROTECTION.startDeratingTemperatureBased];
        const endDerating = mode.value === '0'
            ? this.props.properties[THERMAL_PROTECTION.endDeratingResistorBased]
            : this.props.properties[THERMAL_PROTECTION.endDeratingTemperatureBased];
        const shutOff = mode.value === '0'
            ? this.props.properties[THERMAL_PROTECTION.shutOffResistorBased]
            : this.props.properties[THERMAL_PROTECTION.shutOffTemperatureBased];
        const measureUnit = mode.value === '0'
            ? 'Ohm'
            : '°C';
        const step = mode.value === '0'
            ? 25
            : 1;

        const sensorTypeComponent = mode.value === '0'
            ? null
            : (
                <PropertyDropdown
                    property={sensorType}
                    properties={sensorType.valueMeta.availableValues}
                    type={'faderate'}
                    title={'Sensor Type'}
                    handleChange={this.handleChange} />
            );

        const shutOffEnabled = mode.value === '0'
            ? this.state.isEnabledShutOffResistor
            : this.state.isEnabledShutOffTemperature;

        // if (isNaN(parseInt(shutOff.value))) {
        //     if(shutOff.value==='Off'){
        //         shutOff.valueMeta.initialValue?this.props.handleChange(shutOff.info.name, shutOff.valueMeta.initialValue):this.props.handleChange(shutOff.info.name, shutOff.valueMeta.default)
        //     }
        //     // this.props.handleChange(shutOff.info.name, shutOff.valueMeta.default);
        // }

        const endDeratingMin = shutOff.valueMeta.min !== shutOff.valueMeta.max
            ? (mode.value === '0'
                ? Math.max(endDerating.valueMeta.min, parseInt(shutOff.value !== shutOff.valueMeta.off ? shutOff.value : shutOff.valueMeta.default) + 25)
                : Math.max(endDerating.valueMeta.min, parseInt(startDerating.value) + 1))
            : endDerating.valueMeta.min;

        const endDeratingMax = shutOff.valueMeta.min !== shutOff.valueMeta.max
            ? (mode.value === '0'
                ? Math.min(endDerating.valueMeta.max, parseInt(startDerating.value) - 25)
                : Math.min(endDerating.valueMeta.max, parseInt(shutOff.value !== shutOff.valueMeta.off ? shutOff.value : shutOff.valueMeta.default) - 1))
            : endDerating.valueMeta.max

        const dataChart = this.getDataChart(this.props.properties, shutOffEnabled);
        return (
            <div>
                <div className="flex-row">
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Thermal_Protection" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={enable}
                                title={enable.info.displayName}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>

                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Mode" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyRadio
                                disabled={!this.state.isEnabled}
                                property={mode}
                                isChecked={mode.value === '0'}
                                valueForTrue={"0"}
                                title={<Trans i18nKey="Resistor_Based" />}
                                handleChange={this.handleChange} />
                            <PropertyRadio
                                disabled={!this.state.isEnabled || mode.valueMeta.max === "0"}
                                property={mode}
                                isChecked={mode.value === '1'}
                                valueForTrue={["1"]}
                                title={<Trans i18nKey="Temperature_Based" />}
                                handleChange={this.handleChange} />
                            {
                                sensorTypeComponent
                            }
                        </Card.Body>
                    </Card>

                    <Card className={this.getClassName([startDerating, endDerating, shutOff, deratingLevel])}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Settings" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', display: 'flex' }}>
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={startDerating}
                                border={'border-none'}
                                title={<Trans i18nKey="Start_Derating" />}
                                measureUnit={measureUnit}
                                min={mode.value === '0' ? Math.max(startDerating.valueMeta.min, parseInt(endDerating.value) + 25) : startDerating.valueMeta.min}
                                max={mode.value === '0' ? startDerating.valueMeta.max : Math.min(startDerating.valueMeta.max, parseInt(endDerating.value) - 1)}
                                step={step}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={endDerating}
                                title={<Trans i18nKey="End_Derating" />}
                                measureUnit={measureUnit}
                                min={endDeratingMin}
                                max={endDeratingMax}
                                step={step}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled || !shutOffEnabled || shutOff.valueMeta.min === shutOff.valueMeta.max}
                                checkbox={true}
                                property={shutOff}
                                title={<Trans i18nKey="Shut_Off" />}
                                measureUnit={measureUnit}
                                min={mode.value === '0' ? shutOff.valueMeta.min : Math.max(shutOff.valueMeta.min, parseInt(endDerating.value) + 1)}
                                max={mode.value === '0' ? Math.min(shutOff.valueMeta.max, parseInt(endDerating.value) - 25) : shutOff.valueMeta.max}
                                step={step}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={deratingLevel}
                                border={'border-none'}
                                title={<Trans i18nKey="Derating_Level" />}
                                measureUnit={'%'}
                                min={deratingLevel.valueMeta.min}
                                max={deratingLevel.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{ width: '100%' }}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableAreaChart
                                disabled={!this.state.isEnabled}
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                properties={this.props.properties}
                                dataChart={dataChart}
                                isXDesc={mode.value === '0'}
                                x={{ 'title': mode.value === '0' ? 'Resistor (Ohm)' : 'Temperature (°C)' }}
                                y={{ 'title': 'Output Level (%)' }}
                                min={mode.value === '0' ? { x: (+endDerating.valueMeta.min - 450), y: 0 } : { x: (+startDerating.valueMeta.min - 1), y: 0 }}
                                max={mode.value === '0' ? { x: (+startDerating.valueMeta.max + 100), y: 120 } : { x: (+endDerating.valueMeta.max + 1), y: 120 }}
                                tickValues={{ x: [], y: [] }}
                                rotateYAxis={mode.value === '0'}
                                xLabels={this.getXLabels(dataChart)}
                                yLabels={this.getYLabels(dataChart)}
                                handleChange={this.handleChartChange} />
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }

    getXLabels(dataChart) {

        const labels = [];
        const smallLabels = [];
        const ticks = [];

        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'xLabel-0':
                    ticks.push(el.x);
                    labels.push({ label: el.x, x: el.x });
                    break;
                default:
                    break;
            }
        });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels() {
        const labels = {};

        //insert max label if max value is not present
        const max = 100;
        if (!labels[max]) {
            labels[max] = { label: max, y: max };
        }

        //insert min label if min value is not present
        const min = this.props.properties[THERMAL_PROTECTION.deratingLevel].value;
        if (!labels[min]) {
            labels[min] = { label: min, y: min };
        }

        return Object.keys(labels).map((key) => { return labels[key]; });
    }

    getDataChart(properties, shutOffEnabled) {

        const mode = properties[THERMAL_PROTECTION.mode];

        const deratingLevel = properties[THERMAL_PROTECTION.deratingLevel];

        const shutOff = mode.value === '0'
            ? properties[THERMAL_PROTECTION.shutOffResistorBased]
            : properties[THERMAL_PROTECTION.shutOffTemperatureBased];

        const dataChart = [];

        dataChart.push({
            x: mode.value === '0'
                ? +properties[THERMAL_PROTECTION.startDeratingResistorBased].valueMeta.max + 100
                : +properties[THERMAL_PROTECTION.startDeratingTemperatureBased].valueMeta.min - 1,
            y: 0
        });

        dataChart.push({
            x: mode.value === '0'
                ? +properties[THERMAL_PROTECTION.startDeratingResistorBased].valueMeta.max + 100
                : +properties[THERMAL_PROTECTION.startDeratingTemperatureBased].valueMeta.min - 1,
            y: deratingLevel.valueMeta.max
        });

        dataChart.push({
            x: mode.value === '0'
                ? +properties[THERMAL_PROTECTION.startDeratingResistorBased].valueMeta.max
                : +properties[THERMAL_PROTECTION.startDeratingTemperatureBased].valueMeta.min,
            y: 100
        });

        dataChart.push({
            x: mode.value === '0'
                ? +properties[THERMAL_PROTECTION.startDeratingResistorBased].value
                : +properties[THERMAL_PROTECTION.startDeratingTemperatureBased].value,
            y: 100,
            timeLabel: "xLabel-0",
        });

        dataChart.push({
            x: mode.value === '0'
                ? +properties[THERMAL_PROTECTION.endDeratingResistorBased].value
                : +properties[THERMAL_PROTECTION.endDeratingTemperatureBased].value,
            y: +deratingLevel.value,
            timeLabel: "xLabel-0",
        });

        if (shutOff.value !== shutOff.valueMeta.off) {
            const x = mode.value === '0'
                ? +properties[THERMAL_PROTECTION.shutOffResistorBased].value
                : +properties[THERMAL_PROTECTION.shutOffTemperatureBased].value;
            // dataChart.push({
            //     x: isNaN(x) ?  Math. pow(-10, -1000) : x,
            //     y: +deratingLevel.value,
            //     timeLabel: "xLabel-0",
            // });

            // dataChart.push({
            //     x: isNaN(x) ?  Math. pow(-10, -1000) : x,
            //     y: 0,
            //     timeLabel: "xLabel-0",
            // });
            isNaN(x) ?
                dataChart.push({
                    x: mode.value === '0'
                        ? +properties[THERMAL_PROTECTION.endDeratingResistorBased].valueMeta.min - 450
                        : +properties[THERMAL_PROTECTION.startDeratingTemperatureBased].valueMeta.max + 1,
                    y: +deratingLevel.value
                }) :
                dataChart.push({
                    x: x,
                    y: +deratingLevel.value,
                    timeLabel: "xLabel-0",
                });

            // if (mode.valueMeta.max === '0') {

            //     dataChart.push({
            //         x: +properties[THERMAL_PROTECTION.endDeratingResistorBased].value,
            //         y: +deratingLevel.value,
            //         timeLabel: "xLabel-0",
            //     });

            //     dataChart.push({
            //         x: 0,
            //         y: +deratingLevel.value,
            //         timeLabel: "xLabel-0",
            //     });

            //     dataChart.push({
            //         x: 0,
            //         y: 0,
            //         timeLabel: "xLabel-0",
            //     });

            // }
            // else if (shutOffEnabled) {

            //     dataChart.push({
            //         x: mode.value === '0'
            //             ? +properties[THERMAL_PROTECTION.shutOffResistorBased].value
            //             : +properties[THERMAL_PROTECTION.shutOffTemperatureBased].value,
            //         y: +deratingLevel.value,
            //         timeLabel: "xLabel-0",
            //     });

            //     dataChart.push({
            //         x: mode.value === '0'
            //             ? +properties[THERMAL_PROTECTION.shutOffResistorBased].value
            //             : +properties[THERMAL_PROTECTION.shutOffTemperatureBased].value,
            //         y: 0,
            //         timeLabel: "xLabel-0",
            //     });
            // }
            // else {

            //     dataChart.push({
            //         x: mode.value === '0'
            //             ? 950
            //             : 100,
            //         y: +deratingLevel.value,
            //         timeLabel: "xLabel-0",
            //     });
            // }

        }
        else {
            dataChart.push({
                x: mode.value === '0'
                    ? +properties[THERMAL_PROTECTION.endDeratingResistorBased].valueMeta.min - 450
                    : +properties[THERMAL_PROTECTION.startDeratingTemperatureBased].valueMeta.max + 1,
                y: +deratingLevel.value
            });

            dataChart.push({
                x: mode.value === '0'
                    ? +properties[THERMAL_PROTECTION.endDeratingResistorBased].valueMeta.min - 450
                    : +properties[THERMAL_PROTECTION.startDeratingTemperatureBased].valueMeta.max + 1,
                y: +deratingLevel.value,
            });
        }

        return dataChart;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ThermalProtection);
